import { Chip, IconButton, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import React from "react";
import { moduleLabels, visualizationLabels } from "../widgetConstants";
import { WidgetImage } from "./WidgetImage";

export const WidgetTableRow = ({ widget, onEdit, onDelete }) => {
  return (
    <tr tabIndex={-1}>
      <td>
        <WidgetImage image={widget.image} alt={widget.name} />
      </td>
      <td>
        <h4 className="mb-0">{widget.name}</h4>
        {widget.description && (
          <small className="text-muted">{widget.description}</small>
        )}
      </td>
      <td>{moduleLabels[widget.module] || "-"}</td>
      <td>{visualizationLabels[widget.visualization_type] || "-"}</td>
      <td>{widget.default_height}</td>
      <td>{widget.default_width}</td>
      <td>{widget.permission_required ? "Yes" : "No"}</td>
      <td>
        <Chip
          size="small"
          label={widget.is_active ? "Active" : "Inactive"}
          style={{
            backgroundColor: widget.is_active ? "#4caf50" : "#9e9e9e",
            color: "#fff",
          }}
        />
      </td>
      <td style={{ textAlign: "end", whiteSpace: "nowrap" }}>
        <Tooltip title="Edit widget">
          <IconButton onClick={() => onEdit(widget)} color="primary">
            <EditIcon style={{ color: "orange" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete widget">
          <IconButton onClick={() => onDelete(widget)}>
            <DeleteIcon color="error" />
          </IconButton>
        </Tooltip>
      </td>
    </tr>
  );
};
